function inRole(raw, check) {
    if (!raw || !check) {
        return false;
    }
    if (typeof check === 'object') {
        for (let c of check) {
            if (raw.findIndex(r => r == c) >= 0) {
                return true;
            }
        }
        return false;
    } else {
        return raw.findIndex(r => r == check) >= 0;
    }
}

function resources(who) {
    let tmp = who;
    who = who == 'TENANT' ? 'TENANT_SUPER' : 'SUPER';
    return [{
        l: '自建资源',
        i: 'apps',
        t: who,
        disabled() {
            let a = this.$store.state.account;
            return (a.tenantId == 0 && tmp == 'TENANT') || (a.tenantId != 0 && tmp == 'SYS');
        },
        c: [
            {
                l: '分类管理', r: `${who},CATE`, url: 'home/admin/c/catalog'
            },
            {
                l: '视频管理', r: `${who},MEDIA`, url: 'home/admin/c/media'
            },
            {
                l: '视频浏览', r: 'MEDIA_RO', url: 'home/admin/c/ro_media'
            },
            {
                l: '课件管理', r: `${who},COURSE`, url: 'home/admin/c/courseware'
            },
            {
                l: '课件浏览', r: 'COURSE_RO', url: 'home/admin/c/ro_courseware'
            },
            { l: '题目管理', r: `${who},QUEST`, url: 'home/admin/c/question' },
            { l: '试卷管理', r: `${who},PAPER`, url: 'home/admin/c/paper' },
            { l: '阅读材料管理', r: `${who},ARTICLE`, url: 'home/admin/c/article' }
        ]
    }];
}
const config = {
    LAZY_TASK_THRESHOLD: 5000,
    baseUrl: '/a',
    appName: '道路运输从业人员教育云平台',
    company: '北京通安信息技术有限公司',
    slogan: '道路运输行业安全培训领先品牌',
    icp: '京ICP备12048479号-1',
    version: '2026/01/12',
    links: [
        {
            l: '培训监管',
            i: 'assessment',
            t: 'TENANT',
            c: [
                { l: '学员概况', r: 'MONITOR', url: 'home/my/mo/stu/dash' },
                { l: '培训概况', r: 'MONITOR', url: 'home/my/mo/clazz/dash' },
                { l: '企业概况', r: 'MONITOR', url: 'home/my/mo/org/dash' },
                { l: '重点关注企业', r: 'MONITOR', url: 'home/my/mo/focus/org' },
                /*
                { l: '培训数据抽查', r: 'MONITOR', url: 'home/my/2' },
                { l: '异常数据', r: 'MONITOR', url: 'home/my/3' },
                { l: '企业', r: 'MONITOR', url: 'home/my/4' },
                { l: '重点关注企业', r: 'MONITOR', url: 'home/my/5' },
                { l: '从业人员', r: 'MONITOR', url: 'home/my/6' },
                { l: '重点关注从业人员', r: 'MONITOR', url: 'home/my/7' },
                { l: '发布公告', r: 'MONITOR', url: 'home/my/8' },
                */
                { l: '问卷调查', r: 'MONITOR', url: 'home/admin/c/survey' },
                { l: '企业通知', r: 'MONITOR', url: 'home/admin/c/notice' }
            ]
        },
        {
            l: '培训管理',
            i: 'work_outline',
            t: 'TENANT',
            c: [
                { l: '培训概况', r: 'TENANT_SUPER,ENANT_STATS', url: 'home/admin/my/tenant/dash' },
                { l: '培训方案', r: 'TENANT_SUPER,TENANT_CR', url: 'home/admin/c/crule' },
                { l: '培训计划', r: 'TENANT_SUPER,TENANT_C', url: 'home/admin/my/tenant/clazz' },
                {
                    l: '全局培训计划', r: 'TENANT_SUPER,TENANT_C', url: 'home/admin/my/tenant/g_clazz', disabled() {
                        let a = this.$store.state.account;
                        return a && a.enableFlatOrg;
                    }
                },
                {
                    l: '培训计划查看', r: 'TENANT_C_RO', url: 'home/admin/my/tenant/ro_clazz', disabled() {
                        return inRole(this.$store.state.account.roles, ['ROLE_TENANT_C']);
                    }
                },
                {
                    l: '全局培训计划查看', r: 'TENANT_C_RO', url: 'home/admin/my/tenant/g_ro_clazz', disabled() {
                        let a = this.$store.state.account;
                        return inRole(a.roles, ['ROLE_TENANT_C']) || (a.enableFlatOrg);
                    }
                },
                {
                    l: '课堂学习', r: 'TENANT_SUPER,TENANT_C_ROOM', url: 'home/admin/my/tenant/room/clazz'
                },
                { l: '学员管理', r: 'TENANT_SUPER,TENANT_STU', url: 'home/admin/my/tenant/stu' },
                { l: '异常学员', r: 'TENANT_SUPER,TENANT_STU_EX', url: 'home/admin/my/tenant/ex_stu' },
                { l: '选课情况', r: 'TENANT_SUPER,TENANT_SC', url: 'home/admin/my/tenant/clzstu' },
                { l: '学员标记字典', r: 'TENANT_SUPER,TENANT_SETTING', url: 'home/admin/my/tenant/clz_stu_tag', disabled() { let a = this.$store.state.account; return a.orgId; } },
                { l: '批量培训计划创建', r: 'TENANT_SUPER,TENANT_BATCH_C', url: 'home/admin/my/tenant/proto/clazz', disabled() { let a = this.$store.state.account; return a.orgId || a.enableFlatOrg; } }
            ]
        },
        {
            l: '系统管理',
            i: 'settings',
            t: 'SYS',
            c: [{
                l: '租户管理', r: 'SUPER,TENANT', url: 'home/admin/sys/tenant'
            }, {
                l: '系统账号管理', r: 'SUPER,ACCOUNT', url: 'home/admin/sys/acc'
            }, {
                l: '租户账号管理', r: 'SUPER,TENANT', url: 'home/admin/sys/t_acc'
            }, {
                l: '领域管理', r: 'SUPER,DOMAIN', url: 'home/admin/sys/domain'
            },
            /*{
                l: 'APP配置', r: 'SUPER', url: 'home/admin/sys/app'
            },*/ {
                l: '学习提醒设置', r: 'SUPER', url: 'home/admin/sys/alert/rule'
            }, {
                l: '模板管理', r: 'SUPER', url: 'home/admin/sys/report/tmpl'
            }, {
                l: '问卷调查', r: 'SUPER,SURVEY', url: 'home/admin/c/survey'
            },
            { l: '企业通知', r: 'SUPER,NOTICE', url: 'home/admin/c/notice' },
            { l: '培训归档管理', r: 'SUPER', url: 'home/admin/sys/clazz' },
            { l: '操作日志', r: 'SUPER', url: 'home/admin/sys/trace/log' },
            { l: '系统配置', r: 'SUPER', url: 'home/admin/sys/app/cfg' }]
        },
        {
            l: '培训管理',
            i: 'work_outline',
            t: 'SYS',
            c: [
                { l: '培训方案', r: 'SUPER', url: 'home/admin/c/crule' }
            ]
        },
        {
            l: '应用管理',
            i: 'shop',
            t: 'SYS',
            c: [
                { l: "应用管理", r: 'SUPER,MODULE', url: 'home/admin/sys/module' },
                { l: '车辆检查报表模版', r: 'SUPER,SYS_VEHICLE_C', url: 'home/admin/m/sys/vehicle/check/tmpl' },
                { l: '车辆检查项管理', r: 'SUPER,SYS_VEHICLE_C', url: 'home/admin/m/sys/vehicle/check/opt' }]
        },
        {
            l: '日常处理',
            i: 'timer',
            t: 'SYS',
            c: [{
                l: '充值管理', r: 'SUPER,RECHARGE', url: 'home/admin/sys/price/rule'
            }, {
                l: '定价审核', r: 'SUPER,PRICE', url: 'home/admin/sys/price/clazz'
            },
            {
                l: '发票管理', r: 'SUPER,BILL', url: 'home/admin/sys/bill'
            }, {
                l: '学员查询', r: 'SUPER,STU', url: 'home/admin/sys/stu'
            }, {
                l: '退课退费', r: 'SUPER,REFUND', url: 'home/admin/sys/refund/log'
            }/*, {
                l: '退课退费记录', r: 'SUPER,REFUND', url: 'home/admin/sys/refund/log'
            }*/, {
                l: '异常学员', r: 'SUPER,STU_ELOG', url: 'home/admin/sys/se/logs'
            }
            ]
        },
        {
            l: '系统管理',
            i: 'settings',
            t: 'TENANT',
            c: [{
                l: '账号管理', r: 'TENANT_SUPER,TENANT_ACC', url: 'home/admin/my/tenant/acc'
            }, {
                l: '监管账号管理', r: 'TENANT_SUPER,TENANT_MONITOR', url: 'home/admin/my/tenant/monitor', disabled() {
                    let a = this.$store.state.account;
                    return !!a.orgId;
                }
            }, {
                l: '机构管理', r: 'TENANT_SUPER,TENANT_ORG', url: 'home/admin/my/tenant/org', disabled() {
                    let a = this.$store.state.account;
                    return a.orgType == 1 || a.enableFlatOrg;
                }
            },
            {
                l: '机构分类', r: 'TENANT_SUPER,TENANT_ORG', url: 'home/admin/my/tenant/org_tag', disabled() {
                    let a = this.$store.state.account;
                    return !!a.orgId || a.enableFlatOrg;
                }
            },
            { l: '问卷调查', r: 'TENANT_SUPER,SURVEY', url: 'home/admin/c/survey' },
            {
                l: '企业通知', r: 'TENANT_SUPER,NOTICE', url: 'home/admin/c/notice', disabled() {
                    return this.$store.state.account.orgType == 1;
                }
            },
            {
                l: '邀请管理', r: 'TENANT_SUPER,TENANT_INVITOR', url: 'home/admin/my/tenant/invitor'
            }, {
                l: '字典管理', r: 'TENANT_DICT,SUPER', url: 'home/admin/my/tenant/dict', disabled() {
                    return !!this.$store.state.account.orgId;
                }
            },
                /*
                {
                    l: '应用管理', r: 'TENANT_SUPER,TENANT_SETTING', url: 'home/admin/my/module', disabled() {
                        return this.$store.state.account.orgType != 1;
                    }
                }
                */
            ]
        },
        ...resources('SYS'),
        ...resources('TENANT'),
        {
            l: '收费管理',
            i: 'payment',
            t: 'TENANT',
            c: [
                {
                    l: '充值与结算', id: 'recharge', r: 'TENANT_SUPER,TENANT_FEE', url: 'home/admin/my/tenant/price/recharge', diabled() {
                        this.$store.state.account.feeMode == 3;
                    }
                },
                /*
                {
                    l: '机构限制', id: 'price_limit', r: 'TENANT_SUPER,TENANT_FEE', url: 'home/admin/my/tenant/price/limit', diabled() {
                        this.$store.state.account.feeMode == 3;
                    }
                },*/
                { l: '培训计划定价', r: 'TENANT_SUPER,TENANT_FEE', url: 'home/admin/my/tenant/price/clazz' }
            ],
            disabled() {
                let acc = this.$store.state.account;
                return acc.feeMode == 1 || acc.tenantId == 0 || !!acc.orgId;
            }
        },
        {
            l: '车辆管理',
            i: 'local_shipping',
            t: 'TENANT',
            disabled() { return this.$store.state.account.orgType != 1; },
            c: [
                { l: '车辆信息管理', r: 'VEHICLE', url: 'home/admin/m/my/tenant/vehicle/mgr' }
            ]
        },
        {
            l: '车辆检查',
            i: 'local_offer',
            t: 'TENANT',
            disabled() { return this.$store.state.account.orgType != 1; },
            c: [
                { l: '车辆三检', r: 'VEHICLE_C', url: 'home/admin/m/my/tenant/vehicle/three/check/log' },
                { l: '其它检查', r: 'VEHICLE_C', url: 'home/admin/m/my/tenant/vehicle/check/cfg' }
            ]
        },
        {
            l: '承诺书',
            i: 'how_to_reg',
            t: 'TENANT',
            disabled() { return this.$store.state.account.orgType != 1; },
            c: [
                { l: '承诺书管理', r: 'PROMISE_MGR', url: 'home/admin/m/my/tenant/promise/mgr' }
            ]
        },
        {
            l: '短视频', i: 'ondemand_video', t: 'TENANT',
            c: [
                {
                    l: '分类管理', r: 'TENANT_SUPER,TENANT_SHORT_V', url: 'home/admin/my/tenant/video/category'
                },
                {
                    l: '视频管理', r: 'TENANT_SUPER,TENANT_SHORT_V', url: 'home/admin/my/tenant/video/video'
                },
                {
                    l: '专辑管理', r: 'TENANT_SUPER,TENANT_SHORT_V', url: 'home/admin/my/tenant/video/album'
                }
            ],
            disabled() {
                let a = this.$store.state.account;
                return !a.enableShortVideo || !!a.orgId;
            }
        },
        {
            l: '我的账号',
            i: 'perm_identity',
            t: 'ALL',
            c: [
                { l: '账号信息', r: 'LOGIN', url: 'home/my/a' },
                {
                    l: '我的收藏', r: 'LOGIN', url: 'home/my/favorite', disabled() {
                        return this.$store.state.account.type != 1;
                    }
                }
            ]
        }
    ],
    vuetifyTheme: {
        primary: '#0068B7',
        secondary: '#5cbbf6',
        accent: '#0068B7',
        info: '#EA573D',
    },
    vuetifyOptions: {
        customProperties: true,
    }
}

export default {
    use: function (Vue) {
        Vue.const = Vue.prototype.$const = config;
        return config;
    }
}
